import { CSSProperties, useEffect, useState } from 'react';

import LottieView from 'lottie-react-native';
import { Image, ImageProps } from 'react-native';

import Picture from 'components/picture';

import {
  logBadgeAnimationPlaybackCompletion,
  logBadgeAnimationRendererFailure,
} from './badge-animation-observability';
import { ILoyaltyBadge } from './types';
import { BadgeAnimationSourceResult } from './use-badge-animation-source';

const defaultEarnedBadge = require('./default-earned-badge.png');
const defaultLockedBadge = require('./default-locked-badge.png');

export const LoyaltyBadgeImage = ({
  badge,
  style,
  showCelebration = false,
  animationSource,
}: {
  badge: ILoyaltyBadge;
  style: ImageProps['style'];
  showCelebration?: boolean;
  animationSource?: BadgeAnimationSourceResult;
}) => {
  const [showFallbackImage, setShowFallbackImage] = useState(false);

  const { imageId, imageAlt, earnedAt, name } = badge;
  const source = showCelebration ? animationSource?.source : undefined;
  const sourceIdentity = animationSource?.assetIdentifier;

  useEffect(() => {
    setShowFallbackImage(false);
  }, [sourceIdentity]);

  if (source && animationSource && !showFallbackImage) {
    return (
      <LottieView
        style={style}
        webStyle={style as CSSProperties}
        source={source}
        autoPlay
        loop={false}
        resizeMode="contain"
        onAnimationFailure={() => {
          logBadgeAnimationRendererFailure({
            assetIdentifier: animationSource.assetIdentifier,
            preparationMode: animationSource.preparationMode,
            retryCount: animationSource.retryCount,
          });
          setShowFallbackImage(true);
        }}
        onAnimationFinish={isCancelled => {
          if (!isCancelled) {
            logBadgeAnimationPlaybackCompletion({
              assetIdentifier: animationSource.assetIdentifier,
              preparationMode: animationSource.preparationMode,
              retryCount: animationSource.retryCount,
            });
          }
        }}
      />
    );
  }

  if (imageAlt) {
    return (
      <Picture
        style={style}
        alt={imageAlt}
        image={{ asset: { _id: imageId } }}
        accessibilityLabel={imageAlt}
        objectFitContain
      />
    );
  }

  return (
    <Image
      style={style}
      source={earnedAt ? defaultEarnedBadge : defaultLockedBadge}
      alt={name}
      accessibilityLabel={name}
    />
  );
};
